import React from 'react';
import Head from 'next/head';
import Link from 'next/link';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import PageHeader from '../../components/PageHeader';
import TextSection from '../../components/TextSection';
import ActionSection from '../../components/ActionSection';
import NevoBanner from '../../components/NevoBanner';
import links from '../../helper/links';

import styles from './styles.module.scss'
import FleetTransitionBackground from '../../public/assets/images/fleet-transition-header.jpg';
import FleetTransitionImage from '../../public/assets/images/fleet-transition-background.jpg'
import eventGTM from '../../lib/gtag';


export default function FleetTransitionPage()  {
  return (
    <>
      <Head>
        <title>Fleet Transition | Nevo Advisory</title>
      </Head>

      <Header black transparent />

      <PageHeader backgroundImage={FleetTransitionBackground.src} className={styles.homeChargingHeader}>
        <h1 className='page-header-h1'>Fleet Transition.</h1>
      </PageHeader>

      <div className={`${styles.homeChargingPage} page-holder`}>
        <TextSection 
          header="At Nevo Advisory, we specialise in helping your company transition your current fleet to electric."
          text="This may not happen today or tomorrow, but we can give you the advice and data to help you make an educated decision when the time is right. There are many reasons to transition to electric vehicles. It may be for environmental or CSR reasons, or you may want to reduce your fleet’s tailpipe emissions which will have a positive effect on your organisations carbon footprint."
        />

        <div className="image-section section" style={{ backgroundImage: `url(${FleetTransitionImage.src})` }}>&nbsp;</div>

        <TextSection 
          textLeft={<>
            It may also be because you can see the cost benefit of electric vehicles or TCO (Total Cost of Ownership). The cost to service an electric vehicle is less than traditional internal combustion engines due to less moving parts. The running costs associated with EVs (electric vehicles) are also less if managed correctly. We can also provide you with advice on how to manage these running costs. Check out our charging section <Link href={links.energy_management} passHref><a className='link' onClick={() => eventGTM('clickedOnEnergyManagementOnFleetPage')}>here</a></Link>.
          </>}
          text={<>
            EU regulations and the availability of right-hand drive vehicles will also play a factor in transitioning your fleet of vehicles to electric. Our extensive knowledge of the electric vehicle landscape makes us the perfect advisory partner to help you select the correct EV based on the individual driving behaviors and requirements across the business. You can see a full list of EV’s both company cars and LCV (<a href={links.nevo_vehicles} className='link' target='_blank' rel='noreferrer' onClick={() => eventGTM('clickedOnLightCommercialVehiclesOnFleetPage')}>light commercial vehicles</a>).
          </>}
        />

        <ActionSection 
          header="Arrange an initial call"
          text="Ready to make the switch to electric? Contact us today to discover how we can help you transition to a more sustainable and future proof vehicle fleet."
          buttonText="Contact Us"
          href="/contact-us"
        />

        <NevoBanner />
      </div>

      <Footer />
    </>
  )
};
